import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, SuccessHttpResponse } from '../../../models/https';
import { RiskSummary, RiskWindow } from '../../../models/risk/risk.model';
import useHttps from '../../useHttps';

const useRiskSummary = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState<RiskSummary | null>(null);

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(err?.response?.data?.message ?? 'Failed to load risk summary');
  };

  const fetchSummary = (window: RiskWindow) => {
    request(
      { url: 'api/v1/admin/risk/summary', method: 'get', params: { window } },
      ({ data }: SuccessHttpResponse<RiskSummary>) => setSummary(data),
      setLoading,
      onError
    );
  };

  return { summary, loading, fetchSummary };
};

export default useRiskSummary;
